// extracted by mini-css-extract-plugin
export default {"app":"App_app__PfKPF","main":"App_main__eFVIY","future":"App_future__69VZu","grafic":"App_grafic__zfuwo"};